const mEditionMapChart = {
  mEditionMapChart: {
    quote: {
      firstText: 'Aún no tienes caminos creados en tu mapa.',
      secondText: 'Para ver el gráfico y los puntajes de cada equipo primero debes crear caminos ingresando a'
    }
  }
}

export default mEditionMapChart
